import * as types from './types';

function setDailyMinimumPricingForTransMode(transMode, data, meta) {
    return {
        meta,
        payload: {
            transMode,
            data,
        },
        type: types.SET_DAILY_MINIMUM_PRICING_FOR_TRANS_MODE,
    };
}

function setDailyMinimumPricing(data, meta) {
    return {
        meta,
        payload: {
            data,
        },
        type: types.SET_DAILY_MINIMUM_PRICING,
    };
}
export {
    setDailyMinimumPricing,
    setDailyMinimumPricingForTransMode,
};
